import React, { useState, useContext ,useEffect} from 'react';
import CancelIcon from '@material-ui/icons/Close';
import API from '../../services/api';
import TrackContext from '../../contexts/track-context';
import {ReactComponent as Play } from '../../assets/play.svg';
import {ReactComponent as Pause } from '../../assets/pause.svg';
import Amplitude from 'amplitudejs'
import Helper from '../../services/helper'
import { Link, useHistory } from 'react-router-dom';
import "./style.css";
import MewoService from '../../services/mewoService';
import Constants from '../../services/constants';
import { toast } from 'react-toastify';
import { ErrorToast, WarningToast } from '../../pure-components/CustomToast';
import { duration } from '@material-ui/core';
import { BouncingLoader } from '../../pure-components/Loader';

function AiSearch(props) {
  let trackContext = useContext(TrackContext);
  const history = useHistory();
  const {
    searchkey,
    setSearchkey,
    initialRouting,
    setinitialRouting,
    setTrackFilter
  } = trackContext;
  const [searchAI,setSearchAI]=useState(false);
  const [panel,setPanel]=useState([]);
  const [totalPanel,setTotalPanel]=useState(0);
  const [track,setTrack]=useState([]);
  const [totalTrack,setTotalTrack]=useState(0);
  const [trackCount, setTrackCount] = useState(0);

  const [loadingTracks, setLoadingTracks] = useState(false);
  const [loadingAlbums, setLoadingAlbums] = useState(false);

  const setAISearch = (e) => {
    if (e.key !== 'Enter' && e.target.value !== "" && e.target.value.startsWith('https://')) {
      props.handleAISearch(e.target.value);
      props.handleAISearchmusic(e.target.value);
      
    }
    if (e.key === 'Enter' && e.target.value !== "" && e.target.value.startsWith('https://')) {

      if(trackContext.path==="/" ||trackContext.path.startsWith("/search/track/")||trackContext.path.startsWith("/search/albums") ){
      history.push(`/search/track/`)
    }

    if(trackContext.path==="/sound-design" ||trackContext.path.startsWith("/sound-design/search/track/")||trackContext.path.startsWith("/sound-design/search/albums") ){
      history.push(`/sound-design/search/track/`)
    } 

      props.handleAISearch(e.target.value); 
      // props.handleAISearchmusic(e.target.value);
      
    }
  }
   const determineTrackCount = () => {
    const width = window.innerWidth;

    if (width <= 480) {
      return 4; // Mobile
    } else if (width <= 768) {
      return 6; // Tablet
    } else {
      return 10; // Desktop
    }
  };

  useEffect(() => {
    const updateTrackCount = () => {
      setTrackCount(determineTrackCount());
    };

    // Set initial count
    updateTrackCount();

    // Update on window resize
    window.addEventListener('resize', updateTrackCount);

    // Clean up on unmount
    return () => window.removeEventListener('resize', updateTrackCount);
  }, []);

  useEffect(() => {

  },[loadingTracks, loadingAlbums])
  const getTrackList = Helper.debounce(async(e) => {
    if(e?.trim()?.length === 0)
      return;
    trackContext.setSearch(true)
    setSearchAI(e ? true:false); 
    setSearchkey(e); 
    
    setLoadingTracks(true);
    setLoadingAlbums(true);
    const trackfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": e,
                "Negative": "false"
            }
        },
        "ResultView": {
            // "Sort_Predefined": "EvokeRanking",
            "View" : "Track",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-deim,-rdt,-cdc-num",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10
        }
      }
    };
    await loadMusicData(trackfilter).finally(() => {setLoadingTracks(false)});

    const albumfilter = {
      "SearchFilters": {
        "SearchType": "Normal",
        "IncludeInactive": "false",
        "MainOnly": "true",
        "SearchTermBundle": {
            "St_Keyword_Aggregated": {
                "ExactPhrase": "false",
                "Wildcard": "false",
                "DisableKeywordGroup": "false",
                "OrOperation": "false",
                "Keywords": e,
                "Negative": "false"
            }
        },
        "ResultView": {
            "View" : "Album",
            "Sort_Predefined": "RankExpression",
            "RankExpression": "-max(deim_album)",
            
            // "Sort_Predefined": "EvokeRanking",
            "Evoke_PrioritizeBPM": false,
            "Evoke_SuppressVocals": false,
            "Skip": "0",
            "Limit": 10
        }
      }
    };

    await loadMusicData(albumfilter, true).finally(() => {setLoadingAlbums(false)});;

  }, 800)
  
  const loadMusicData = async(filter, album = false) => {

    await API.loadSearchedTrackData(filter).then((resp) => {
      // console.log("response data : ", resp)
      
      if(album){
        setPanel(resp.data.Albums);
        setTotalPanel(resp.data?.TotalAlbums);

        if(!resp?.data?.Albums || resp?.data?.Albums?.length === 0){
          toast(({ closeToast }) => <WarningToast  message={"No album found for searched query."}/>);
          return;
        }
      }else{
        setTrack(resp.data.Tracks);
        setTotalTrack(resp.data?.TotalTracks);

        if(!resp?.data?.Tracks || resp?.data?.Tracks?.length === 0){
          toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
          return;
        }
      }
      
      
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
    });
    
  }

  const playTrack = async(trackData) => {
    if (trackData.trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      // console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      // console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }

    trackContext.setPlayingFrom(props.pageId)
    trackContext.setCurrentTrack(Helper.playTrackURL(trackData.trackId));
    trackContext.setCurrentTrackDetail({id : trackData.trackId, 
      display_title : trackData.title,
      description : trackData.description || "",
      duration : trackData.duration,
      bpm : trackData.bpm, 
      album : {id : trackData.albumId, name : trackData.album, image : {original : {url : Helper.getArtworkURL(trackData.albumId)}}},
      artist: trackData.artistName,
      isVersion : trackData.isVersion || false
    });
    
    const dataObj = {
      actionType : Constants.ACTION.PLAY,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addPlayHistory(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("history", JSON.stringify(res.history)); 
      } else {
        console.log("Track Adding in play history failed.", res);
      }
    }).catch(err => {
      console.log("Track Adding in play history failed.", err);
    });
  }

  const seeTrackListData = () => {
    props.handleAISearch(trackContext.searchkey);
    trackContext.setSearchAlbums(false);
    
    history.push(`/music/tracks/${trackContext.searchkey}`)
    props.closeProjectModal();
  }
  const seeAlbumListData = () => {
    //load album list data  
    // trackContext.setSearchAlbums(true);
    // props.handleAISearchmusic(trackContext.searchkey,props.checked);
    history.push(`/music/albums/${trackContext.searchkey}`)
    props.closeProjectModal();
  }


  return (
    <div className='aisearch-modal fixed right-0 top-0 shadow-md'>
      <div className='py-4 px-6 lg:p-4 mt-4 lg:mr-16 pb-0 flex justify-end'>
        <CancelIcon
          onClick={() => {props.closeProjectModal()}}
          className='text-black cursor-pointer'
          style={{ fontSize: '32px' }}
        />
      </div>

      <div className='aisearch-wrapper w-full p-4 overflow-auto'>
      
          <div className="w-full lg:px-40">
          <input
            autoFocus={true}
            onChange={(e) => { getTrackList(e.target.value) }}
            onKeyDown={setAISearch}
            className="placeholder-textGray-100 font-light p-2 mb-2 w-full text-2xl lg:text-2xl focus:outline-none border-b text-black bg-transparent" 
            placeholder='Search Music...'
          />
          { !searchAI &&
          <div className="flex w-full flex-wrap">
            {/* <div className="w-full lg:w-1/5 ">
              <div className="font-normal text-base">Search  by:</div>
            </div> */}
            {/* <div className="w-full mt-3 lg:mt-0 lg:w-2/5 pr-2">
              <div className="font-semibold text-base">URL</div>
              <div className="text-sm text-textGray-100">Copy and paste a URL from a YouTube or Vimeo video here and our A.I. Search kicks into action to list the best matched tracks in our music!</div>

            </div> */}
            <div className="w-full mt-3 lg:mt-0 lg:w-2/5 pr-2">
              <div className="font-semibold text-base">Keyword</div>
              <div className="text-sm text-textGray-100">Enter a keyword to search by Track Title, Description or by Album Name</div>

            </div>
          </div>
          }
           { searchAI && 
           <>
           <div className="w-full pb-4">
           <div className="font-normal text-lg">Search result for "{searchkey}"</div>
            </div>
            <div className="flex flex-wrap">
            <div className="w-full  sm:w-2/4 pr-2 ">
              <div className="font-semibold text-base pb-4">Tracks ({totalTrack})</div>
              <div className="album-wrapper sm:overflow-y-auto">
                {loadingTracks ?  
                  <div className='w-full'>
                    <BouncingLoader />
                  </div>
                :
                track?.map(item=>{
                  return <div className="flex"> <div className='self-center play-button'>
                  <div
                    aria-label="play/pause"
                    className='outline-none focus:outline-none play-button border-symStrokeGrey cursor-pointer'
                   onClick={() => playTrack({
                    trackId : item.ID,
                    title : item.DisplayTitle,
                    description : item.Comment,
                    duration : item.LengthSeconds,
                    bpm : item.Bpm,
                    albumId : item.AlbumID,
                    album : item.AlbumTitle,
                    artistName : item.Artist
                   })}
                  >
                    {                  
                  (trackContext.playPause && item.ID === trackContext.currentTrackDetail.id) ? 
                   <Pause className='outline-none' />
                        :
                        <Play className='outline-none' />
                    }
                  </div>
                </div>
                <div className='w-4/6 self-center p-2'>
                  <h1 className='text-base mr-2 text-black capitalize' > {item.DisplayTitle?.toLowerCase()}</h1>
                  <h2 className='text-xs self-center text-textGray-100 capitalize'>{item.LibraryName?.toLowerCase()} </h2>
                </div>
                </div>
                })
              }
              </div>
              {totalTrack > 0 &&
                ( 
                  <div className="w-1/2 text-center font-normal text-sm pb-4 cursor-pointer see-tracks"
                  onClick={seeTrackListData} ><span className='showborder'>See Tracks List</span></div>
                )}
            </div>
            {panel?.length > 0 && 
              <div className="w-full sm:w-2/4 pr-2 " >
                <div className="font-semibold text-base pb-4">Albums ({totalPanel})</div>
                  <div className='album-wrapper lg:overflow-y-auto'>
                  {loadingAlbums ? 
                    <div className='w-full'>
                      <BouncingLoader />
                    </div>
                  :
                  panel?.map(item=>{
                      return <div className="flex mb-3">
                    <div className='w-20 h-20  overflow-hidden'>
                      <Link className="self-center" to={`/album/${item.ID}`}  >
                      <img src={Helper.getArtworkURL(item.ID)} className="cursor-pointer" width='100%' alt='album art' onError={(e)=>trackContext.setDefaultImage(e)}/>
                      </Link>
                    </div>
                    <div className='w-4/6 self-center p-2'>
                      <h1 className='text-base mr-2 text-black capitalize' > {item.Name?.toLowerCase()}</h1>
                      <h2 className='text-xs self-center text-textGray-100 capitalize'>{item.LibraryName?.toLowerCase()} </h2>
                    </div>
                    </div>
                    })
                  }
                  </div>
                  {totalPanel> 0 &&(
                    <div className="w-1/2 text-center font-normal text-sm pb-4 cursor-pointer see-tracks"
                    onClick={seeAlbumListData} > <span className='showborder'>See Albums List</span></div>
                  )}
                </div>

            }
            </div>
           </>
          } 
        </div>
    
      {/* {
        searchAI &&
        <div className='w-full px-10 py-10' >
          <input
            autoFocus={true}
            onChange={(e) => { getTrackList(e.target.value) }}
            onKeyDown={setAISearch}
            className='p-2 mb-2 w-6/12 text-lg focus:outline-none border-b text-black bg-transparent'
            placeholder='Search Music...'
          />
         </div> 
      } */}
      </div>
    </div>
  )
}

export default AiSearch;